var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomInIcon = function SvgZoomInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "m18.57 16.453-3.161-3.162a7.871 7.871 0 1 0-2.126 2.126l3.17 3.162a1.502 1.502 0 0 0 2.444-.488 1.5 1.5 0 0 0-.326-1.638zM8.875 2.491A6.384 6.384 0 1 1 2.49 8.875a6.39 6.39 0 0 1 6.384-6.384z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M6.246 9.626h1.877v1.878a.751.751 0 0 0 1.503 0V9.626h1.877a.75.75 0 1 0 0-1.502H9.626V6.246a.751.751 0 0 0-1.503 0v1.878H6.246a.751.751 0 1 0 0 1.502"
  })));
};
export { SvgZoomInIcon as ReactComponent };